<template>
  <div class="bg-white dark:bg-gray-800 p-4 rounded-lg shadow">
    <div class="ooloja-card-default__body">
      <h3 class="text-lg font-semibold mb-4">Curva ABC de Produtos</h3>
      <div class="chart-container">
        <Bar :data="chartData" :options="chartOptions" :height="300" />
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed } from "vue";
import { Bar } from "vue-chartjs";
import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  BarElement,
  CategoryScale,
  LinearScale,
} from "chart.js";

// Registrar os componentes necessários do Chart.js
ChartJS.register(Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale);

// Props para receber os dados
const props = defineProps({
  dados: {
    type: Array,
    required: true,
  },
});

// Dados do gráfico
const chartData = computed(() => ({
  labels: props.dados.map((item) =>
    item.titulo.length > 20 ? item.titulo.substring(0, 17) + "..." : item.titulo
  ), // Truncar títulos longos
  datasets: [
    {
      label: "Receita Total (R$)",
      data: props.dados.map((item) => item.receita_total),
      backgroundColor: props.dados.map((item) => {
        if (item.categoria === "A") return "#4CAF50"; // Verde para categoria A
        if (item.categoria === "B") return "#FFC107"; // Amarelo para categoria B
        return "#F44336"; // Vermelho para categoria C (inclui "Outros")
      }),
      borderColor: props.dados.map((item) => {
        if (item.categoria === "A") return "#4CAF50";
        if (item.categoria === "B") return "#FFC107";
        return "#F44336";
      }),
      borderWidth: 1,
    },
  ],
}));

// Opções do gráfico
const chartOptions = {
  responsive: true,
  maintainAspectRatio: false,
  scales: {
    y: {
      beginAtZero: true,
      title: {
        display: true,
        text: "Receita Total (R$)",
      },
    },
    x: {
      title: {
        display: true,
        text: "Produtos",
      },
      ticks: {
        maxRotation: 45, // Rotacionar rótulos para evitar sobreposição
        minRotation: 45,
        font: {
          size: 10, // Tamanho menor para rótulos
        },
      },
    },
  },
  plugins: {
    legend: {
      display: false,
    },
    tooltip: {
      callbacks: {
        label: function (context) {
          const value = context.parsed.y;
          return `R$ ${value.toLocaleString("pt-BR", { minimumFractionDigits: 2 })}`;
        },
        title: function (context) {
          const item = props.dados[context[0].dataIndex];
          return `${item.titulo} (Categoria ${item.categoria})`;
        },
      },
    },
  },
};
</script>

<style scoped>
.chart-container {
  position: relative;
  height: 300px;
  width: 100%;
}
</style>
